module.exports = __webpack_public_path__ + "img/VL_17_02.371090d3.png";